const generateHtmlIdFromContent = (content) => {
  const regex = /[^A-Za-z 0-9]/g;
  return content.replace(regex, '').split(' ').join('_');
};

export default generateHtmlIdFromContent;
